import { Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';
import { getPaymentProvider } from './TransactionUtils';

export const getPaymentTypes = (Payments, formatMessage) => {
  if (!Payments || Payments.length === 0) {
    return 'No Payments';
  }
  
  const providerNames = Payments.map(payment =>
    getPaymentProvider(payment?.Type, formatMessage),
  );
  
  const uniqueProviders = [...new Set(providerNames)];
  return uniqueProviders.map(provider => {
    const count = providerNames.filter(name => name === provider).length;
    return `${count > 1 ? `${count}x ` : ''}${provider}`;
  }).join(', ');
};

const TransactionsPaymentType = ({ params, formatMessage }) => {
  const { Payments } = params.row;
  const paymentTypes = getPaymentTypes(Payments, formatMessage);
  
  if (paymentTypes === 'No Payments') {
    return <p>No Payments</p>;
  }
  
  return (
    <Tooltip title={paymentTypes}>
      <span>{paymentTypes}</span>
    </Tooltip>
  );
};

export default TransactionsPaymentType;

TransactionsPaymentType.propTypes = {
  payments: PropTypes.object,
  getPaymentProvider: PropTypes.func,
  formatMessage: PropTypes.func,
};